import { canUseDOM } from './canUseDOM';
export default function getScrollbarWidth() {
  var _outer$parentNode;

  if (!canUseDOM) {
    return undefined;
  }

  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px'; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth; // force scrollbars

  outer.style.overflow = 'scroll'; // add innerdiv

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth; // remove divs

  (_outer$parentNode = outer.parentNode) === null || _outer$parentNode === void 0 ? void 0 : _outer$parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}